const contrast = {
    name: "contrast",
    path: "/contrast",
    title: "contrast",
    description: "Utilities for applying contrast filter effects to elements.",
    value: {
        'filter': {
            'contrast-<number>': 'contrast(<number>%)'
        },
    },
    exampleData: [
        {
            "title": "contrast-50, contrast-100",
            "description": "to control an element's contrast:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-4 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg contrast-50",
                        "text": "contrast-50",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg contrast-100",
                        "text": "contrast-100",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg contrast-125",
                        "text": "contrast-125",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg contrast-200",
                        "text": "contrast-200",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="contrast-50" src="/img/mountains.jpg" />
<img class="contrast-100" src="/img/mountains.jpg" />
<img class="contrast-125" src="/img/mountains.jpg" />
<img class="contrast-200" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default contrast;